import { useRouter } from 'next/router'

import { useSubscriptionApplicabilityQueryState } from '~/redux/apis/payment-api'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { selectIsSubscriptionApplicable, setShowSubscriptionPackages } from '~/redux/slices/subscription.slice'
import authService from '~/services/auth.service'
import { AppLanguage } from '~/types/locale'

export default function useShowSubscriptionPackagesPageAfterSSO(): void {
  const authenticated = authService.isAuthenticated()
  const { locale } = useRouter()
  const notUkrainianLanguage = Boolean(locale) && locale !== AppLanguage.UA
  const isSubscriptionApplicable = useAppSelector(selectIsSubscriptionApplicable)
  const { isSuccess, data: showSubscriptionPackages } = useSubscriptionApplicabilityQueryState()
  const dispatch = useAppDispatch()

  if (!authenticated && isSubscriptionApplicable && notUkrainianLanguage) {
    dispatch(setShowSubscriptionPackages(true))
  } else if ((isSuccess && !showSubscriptionPackages) || !notUkrainianLanguage) {
    dispatch(setShowSubscriptionPackages(false))
  }
}
